/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Monitoring_DescInputs */

const en_activity_monitoring_desc = /** @type {(inputs: Activity_Monitoring_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprehensive ledger of all team actions, resource modifications, and system events.`)
};

const es_activity_monitoring_desc = /** @type {(inputs: Activity_Monitoring_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro completo de todas las acciones del equipo, modificaciones de recursos y eventos del sistema.`)
};

const fr_activity_monitoring_desc = /** @type {(inputs: Activity_Monitoring_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registre complet de toutes les actions de l'équipe, des modifications de ressources et des événements système.`)
};

const de_activity_monitoring_desc = /** @type {(inputs: Activity_Monitoring_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umfassendes Hauptbuch aller Teamaktionen, Ressourcenänderungen und Systemereignisse.`)
};

const id_activity_monitoring_desc = /** @type {(inputs: Activity_Monitoring_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buku besar komprehensif dari semua tindakan tim, modifikasi sumber daya, dan kejadian sistem.`)
};

/** @type {(inputs: Activity_Monitoring_DescInputs) => LocalizedString} */
const ja_activity_monitoring_desc = en_activity_monitoring_desc;

/** @type {(inputs: Activity_Monitoring_DescInputs) => LocalizedString} */
const zh_activity_monitoring_desc = en_activity_monitoring_desc;

/** @type {(inputs: Activity_Monitoring_DescInputs) => LocalizedString} */
const ar_activity_monitoring_desc = en_activity_monitoring_desc;

/** @type {(inputs: Activity_Monitoring_DescInputs) => LocalizedString} */
const it_activity_monitoring_desc = en_activity_monitoring_desc;

/** @type {(inputs: Activity_Monitoring_DescInputs) => LocalizedString} */
const ru_activity_monitoring_desc = en_activity_monitoring_desc;

/** @type {(inputs: Activity_Monitoring_DescInputs) => LocalizedString} */
const pt_activity_monitoring_desc = en_activity_monitoring_desc;

/** @type {(inputs: Activity_Monitoring_DescInputs) => LocalizedString} */
const ko_activity_monitoring_desc = en_activity_monitoring_desc;

/**
* | output |
* | --- |
* | "Comprehensive ledger of all team actions, resource modifications, and system events." |
*
* @param {Activity_Monitoring_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const activity_monitoring_desc = /** @type {((inputs?: Activity_Monitoring_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Monitoring_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_activity_monitoring_desc(inputs)
	if (locale === "es") return es_activity_monitoring_desc(inputs)
	if (locale === "fr") return fr_activity_monitoring_desc(inputs)
	if (locale === "de") return de_activity_monitoring_desc(inputs)
	if (locale === "ja") return ja_activity_monitoring_desc(inputs)
	if (locale === "zh") return zh_activity_monitoring_desc(inputs)
	if (locale === "ar") return ar_activity_monitoring_desc(inputs)
	if (locale === "id") return id_activity_monitoring_desc(inputs)
	if (locale === "it") return it_activity_monitoring_desc(inputs)
	if (locale === "ru") return ru_activity_monitoring_desc(inputs)
	if (locale === "pt") return pt_activity_monitoring_desc(inputs)
	return ko_activity_monitoring_desc(inputs)
});